<script lang="ts" setup>
import IconTooltip from '~/components/tooltip/IconTooltip.vue'

interface IProps {
  gapY?: string;
  label: string;
  labelSize?: string;
  row?: boolean;
  labelEllipsis?: boolean;
  tooltip?: string
}

const props = withDefaults(defineProps<IProps>(), {
  gapY: 'gap-y-2',
  row: false,
  labelSize: 'lg',
  labelEllipsis: false,
})

const labelTextSize = computed(() => `text-${props.labelSize}`)
</script>

<template>
  <div
    class="flex"
    :class="{'flex-col': !row, [gapY]: gapY, 'items-center': row, 'overflow-hidden': labelEllipsis}"
  >
    <span
      class="flex shrink-0 items-center gap-x-1 whitespace-nowrap text-primary/40"
      :class="{[labelTextSize]: labelTextSize, 'w-32': row, 'truncate': labelEllipsis}"
    >{{ label }}
      <IconTooltip
        v-if="tooltip"
        :tooltip="tooltip"
      /></span>
    <slot name="content" />
  </div>
</template>

<style scoped>

</style>